import { __extends } from "tslib";
import { Container } from "./container";
import { _TypeStore } from '@babylonjs/core/Misc/typeStore';
/** Class used to create rectangle container */

var Rectangle =
/** @class */
function (_super) {
  __extends(Rectangle, _super);
  /**
   * Creates a new Rectangle
   * @param name defines the control name
   */


  function Rectangle(name) {
    var _this = _super.call(this, name) || this;

    _this.name = name;
    _this._thickness = 1;
    _this._cornerRadius = 0;
    return _this;
  }

  Object.defineProperty(Rectangle.prototype, "thickness", {
    /** Gets or sets border thickness */
    get: function get() {
      return this._thickness;
    },
    set: function set(value) {
      if (this._thickness === value) {
        return;
      }

      this._thickness = value;

      this._markAsDirty();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rectangle.prototype, "cornerRadius", {
    /** Gets or sets the corner radius angle */
    get: function get() {
      return this._cornerRadius;
    },
    set: function set(value) {
      if (value < 0) {
        value = 0;
      }

      if (this._cornerRadius === value) {
        return;
      }

      this._cornerRadius = value;

      this._markAsDirty();
    },
    enumerable: true,
    configurable: true
  });

  Rectangle.prototype._getTypeName = function () {
    return "Rectangle";
  };

  Rectangle.prototype._localDraw = function (context) {
    context.save();

    if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
      context.shadowColor = this.shadowColor;
      context.shadowBlur = this.shadowBlur;
      context.shadowOffsetX = this.shadowOffsetX;
      context.shadowOffsetY = this.shadowOffsetY;
    }

    if (this._background) {
      context.fillStyle = this._background;

      if (this._cornerRadius) {
        this._drawRoundedRect(context, this._thickness / 2);

        context.fill();
      } else {
        context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
      }
    }

    if (this._thickness) {
      if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
        context.shadowBlur = 0;
        context.shadowOffsetX = 0;
        context.shadowOffsetY = 0;
      }

      if (this.color) {
        context.strokeStyle = this.color;
      }

      context.lineWidth = this._thickness;

      if (this._cornerRadius) {
        this._drawRoundedRect(context, this._thickness / 2);

        context.stroke();
      } else {
        context.strokeRect(this._currentMeasure.left + this._thickness / 2, this._currentMeasure.top + this._thickness / 2, this._currentMeasure.width - this._thickness, this._currentMeasure.height - this._thickness);
      }
    }

    context.restore();
  };

  Rectangle.prototype._additionalProcessing = function (parentMeasure, context) {
    _super.prototype._additionalProcessing.call(this, parentMeasure, context);

    this._measureForChildren.width -= 2 * this._thickness;
    this._measureForChildren.height -= 2 * this._thickness;
    this._measureForChildren.left += this._thickness;
    this._measureForChildren.top += this._thickness;
  };

  Rectangle.prototype._drawRoundedRect = function (context, offset) {
    if (offset === void 0) {
      offset = 0;
    }

    var x = this._currentMeasure.left + offset;
    var y = this._currentMeasure.top + offset;
    var width = this._currentMeasure.width - offset * 2;
    var height = this._currentMeasure.height - offset * 2;
    var radius = Math.min(height / 2 - 2, Math.min(width / 2 - 2, this._cornerRadius));
    context.beginPath();
    context.moveTo(x + radius, y);
    context.lineTo(x + width - radius, y);
    context.quadraticCurveTo(x + width, y, x + width, y + radius);
    context.lineTo(x + width, y + height - radius);
    context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    context.lineTo(x + radius, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - radius);
    context.lineTo(x, y + radius);
    context.quadraticCurveTo(x, y, x + radius, y);
    context.closePath();
  };

  Rectangle.prototype._clipForChildren = function (context) {
    if (this._cornerRadius) {
      this._drawRoundedRect(context, this._thickness);

      context.clip();
    }
  };

  return Rectangle;
}(Container);

export { Rectangle };
_TypeStore.RegisteredTypes["BABYLON.GUI.Rectangle"] = Rectangle;